import { render, staticRenderFns } from "./list.vue?vue&type=template&id=66ea6dd6&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=66ea6dd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea6dd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ea6dd6')) {
      api.createRecord('66ea6dd6', component.options)
    } else {
      api.reload('66ea6dd6', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=66ea6dd6&scoped=true&", function () {
      api.rerender('66ea6dd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/securityCheckMgr/accidentRegister/list.vue"
export default component.exports